module.exports = __webpack_public_path__ + "img/cancel.7cc2ec21.svg";